//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from '@/utils/throttle';
export default {
  data: function data() {
    return {
      timeList: [{
        startTime: '',
        endTime: ''
      }]
    };
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showEndTime: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.timeList = val !== null && val !== void 0 && val.length ? val : [{
          startTime: '',
          endTime: ''
        }];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    throttle: throttle,
    changeVal: function changeVal() {
      this.$emit("input", this.timeList);
    },
    removeTime: function removeTime(i) {
      var _this$timeList;
      (_this$timeList = this.timeList) === null || _this$timeList === void 0 ? void 0 : _this$timeList.splice(i, 1);
    },
    addTime: function addTime() {
      var _this$timeList2;
      (_this$timeList2 = this.timeList) === null || _this$timeList2 === void 0 ? void 0 : _this$timeList2.push({
        startTime: '',
        endTime: ''
      });
    }
  }
};